import { api } from "../../../../services/api";

export async function closeAllCashRegister({ companies, token }) {
  await api.post("/closeAllCashRegister", {
    companies,
    token,
  });
}
